// ChildNode.remove
if(!("remove" in Element.prototype)){
  Element.prototype.remove = function(){
    if(this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/childNode.remove.js
// module id = 65
// module chunks = 0